import React from 'react'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { treeAtom } from './atoms'
import { nodeListsWithTypeIssue } from '../TreeVerifications/utility'
import { Box } from '@mui/material'
import { UpdateNodeListsButton } from '../TreeVerifications/NodeListType'

export function NodeListFixes() {
  const tree = useAtomValue(treeAtom)

  const nodeListsWithIssues = tree && nodeListsWithTypeIssue(tree)

  if (!tree || !nodeListsWithIssues?.length) {
    return null
  }

  return (
    <Box padding="10px">
      <Box maxWidth="420px">
        Theres a node list that is missing the node list type. This could be a
        unit node list and causes the tool to not find some units. Press the
        button below to fix these node lists.
      </Box>
      <UpdateNodeListsButton tree={tree} nodeLists={nodeListsWithIssues} />
    </Box>
  )
}
